import { useState } from "react";

import { Button } from "@design-lab/shared";
import { Tooltip, TooltipContent, TooltipTrigger } from "@design-lab/shared/ui/tooltip";
import { useTokenManagement } from "../../model/tokenManagement";
import { useRequestMoreCredits } from "../../model/useRequestMoreCredits";

export function DailyCredits() {
  const { aiCreditsBalance, totalCredits } = useTokenManagement();
  const [showTooltip, setShowTooltip] = useState(false);
  const { handleRequestMore } = useRequestMoreCredits({ deviceType: "desktop" });

  const hasCreditsRemaining = aiCreditsBalance > 0;
  const gradientColorClass = hasCreditsRemaining ? "text-cta-gradient" : "text-gray-400";

  const getProgressBarClassName = (index: number) => {
    const baseClasses = "h-1 w-7";
    const roundedClasses = [
      index === 0 ? "rounded-l-sm" : "",
      index === totalCredits - 1 ? "rounded-r-sm" : ""
    ]
      .filter(Boolean)
      .join(" ");
    const colorClass = index < aiCreditsBalance ? "bg-cta-gradient" : "bg-gray-200";

    return [baseClasses, roundedClasses, colorClass].filter(Boolean).join(" ");
  };

  const handleRequestMoreClick = () => {
    handleRequestMore();
    setShowTooltip(true);
  };

  return (
    <div className="relative w-44 rounded-md border border-blue-700 bg-white p-2 shadow-sm">
      <div className="text-center">
        <h3 className="text-sm font-semibold leading-5 text-gray-700">Daily Weave Credits</h3>
        <div className="mt-2">
          {/* Progress Bar */}
          <div className="flex gap-1">
            {Array.from({ length: totalCredits }, (_, index) => (
              <div key={index} className={getProgressBarClassName(index)} />
            ))}
          </div>
          <p className="mt-1.5 text-xs font-normal leading-[18px]">
            <span className={`text-sm font-bold leading-5 ${gradientColorClass}`}>
              {aiCreditsBalance}/{totalCredits}
            </span>{" "}
            <span className="text-gray-700">remaining today</span>
          </p>
          {aiCreditsBalance === 0 && (
            <Tooltip open={showTooltip}>
              <TooltipTrigger asChild data-testid="request-more-credits-trigger">
                <Button
                  className="mt-1 p-0 text-xs text-gray-500 underline hover:text-gray-700"
                  data-testid="request-more-credits"
                  variant="link"
                  onPress={handleRequestMoreClick}
                >
                  Request more
                </Button>
              </TooltipTrigger>
              <TooltipContent
                side="bottom"
                className="text-background bg-blue-700"
                arrowClassName="bg-blue-700 fill-blue-700"
                onClose={() => setShowTooltip(false)}
              >
                <p className="w-full">
                  We&apos;ll get back to you soon — demand
                  <br />
                  is currently high.
                </p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}
